import http from '@/util/http'
// 产品列表查询
export function productBaseQueryPageAll (type, page, size, data) {
  return http({
    url: `/api/productBase/queryPageAll/${type}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 分页查询产品列表(具体看请求参数)
export function productBaseQueryPageAllNoType (page, size, data) {
  return http({
    url: `/api/productBase/queryPageAll/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 客户详情,协议价模板管理添加协议价产品
export function queryAllByTemPrice (type, page, size, cptId, data) {
  return http({
    url: `/api/productBase/queryAllByTemPrice/${type}/${page}/${size}`,
    method: 'post',
    params: {
      cptId: cptId
    },
    data: data
  })
}
// 添加产品
export function addProduct (data) {
  return http({
    url: '/api/productBase/addProduct',
    method: 'post',
    data: data
  })
}
// 根据产品id获取编辑信息
export function queryProductByIdForEdit (id) {
  return http({
    url: `/api/productBase/queryProductByIdForEdit/${id}`,
    method: 'post'
  })
}
// 批量上线
export function onOffProductLineBatchUp (ids, state) {
  return http({
    url: '/api/productBase/onOffProductLineBatchUp',
    method: 'post',
    params: {
      ids: ids,
      state: state
    }
  })
}
export function queryProductImport () {
  return http({
    url: '/api/SystemOpenController/queryProductImport',
    method: 'post'

  })
}
// /api/SystemOpenController/queryProductImport
// 批量下载
export function onOffProductLineBatchDown (ids, state) {
  return http({
    url: '/api/productBase/onOffProductLineBatchDown',
    method: 'post',
    params: {
      ids: ids,
      state: state
    }
  })
}
// 根据产品分类ID查询所拥有的参数清单
export function queryProductParam (cid) {
  return http({
    url: `/api/productClassParam/queryProductParam/${cid}`,
    method: 'get'
  })
}
// 添加产品参数与值
export function addProductClassParam (data) {
  return http({
    url: '/api/productClassParam/addProductClassParam',
    method: 'post',
    data: data
  })
}
// 只添加产品参数值
export function addProductClassParamValue (proId, data) {
  return http({
    url: `/api/productClassParamvalue/addProductClassParamValue/${proId}`,
    method: 'post',
    data: data
  })
}
// 只添加产品参数值
export function addProductClassParamValueData (data) {
  return http({
    url: '/api/productClassParamvalue/addProductClassParamValue',
    method: 'post',
    data: data
  })
}

// 修改产品基本信息
export function productBaseUpdateProduct (data) {
  return http({
    url: '/api/productBase/updateProduct',
    method: 'post',
    data: data
  })
}
// 删除组合产品子型号
export function deleteProductCombine (ids, pid) {
  return http({
    url: '/api/productBase/deleteProductCombine',
    method: 'post',
    params: {
      ids: ids,
      pid: pid
    }
  })
}
// 获取所有品牌信息
export function brandQueryPageAll () {
  return http({
    url: '/api/brandBase/queryAll',
    method: 'get'
  })
}

// 根据品牌id获取所属系列
export function querySeriesByBrandId (id) {
  return http({
    url: `/api/brandSeries/querySeriesByBrandId/${id}`,
    method: 'get'
  })
}
// 分页查询所有品牌列表
export function brandBaseQueryPageAll (page, size, data) {
  return http({
    url: `/api/brandBase/queryPageAll/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 分页查询所有系列列表
export function queryPageAllByPrice (type, page, size, cptId, data) {
  return http({
    url: `/api/brandSeries/queryPageAllByPrice/${type}/${page}/${size}`,
    method: 'post',
    params: {
      cptId: cptId
    },
    data: data
  })
}
/// 供应商添加经营系列
export function queryAllBySeriesGroup (page, size, data) {
  return http({
    url: `/api/brandSeries/queryAllBySeriesGroup/${page}/${size}`,
    method: 'post',
    data: data
  })
}
/// 供应商详情页添加经营系列
export function brandSeries (page, size, suId, data) {
  return http({
    url: `/api/brandSeries/queryAllBySeriesGroup/${page}/${size}/${suId}`,
    method: 'post',
    data: data
  })
}
// 供应商详情页添加代理品牌
export function queryAllByBrandIds (page, size, suId, data) {
  return http({
    url: `/api/brandBase/queryAllByBrandIds/${page}/${size}/${suId}`,
    method: 'post',
    data: data
  })
}
// 添加页添加代理品牌
export function brandBase (page, size, data) {
  return http({
    url: `/api/brandBase/queryAllByBrandIds/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 根据品牌ID获取所有的系列
export function brandBaseQuerySeriesByBrandId (id, data) {
  return http({
    url: `/api/brandBase/querySeriesByBrandId/${id}`,
    method: 'get',
    params: {
      key: data
    }
  })
}
// 根据系列id获取型号
export function queryAllProductByBrandSeriesId (id, data) {
  return http({
    url: `/api/productBase/queryAllProductByBrandSeriesId/${id}`,
    method: 'get',
    params: {
      key: data
    }
  })
}
// 产品下线
export function changeToOffLine (ids) {
  return http({
    url: '/api/productBase/changeToOffLine',
    method: 'post',
    data: {
      ids: ids
    }
  })
}
// 分页查询所有分类信息
export function productType (cid, page, size) {
  return http({
    url: `/api/productClass/queryPageAll/${cid}/${page}/${size}`,
    method: 'post'
  })
}
// 获取所有系列牌信息(名称)
export function seriesInformation () {
  return http({
    url: '/api/brandSeries/queryAll',
    method: 'get'
  })
}
// 系列组模糊查询(名称)
export function brandGroup (key) {
  return http({
    url: `/api/brandGroup/queryAll?key=${key}`,
    method: 'get'
  })
}
// 查询所有产品分类信息[下拉选择联动]
export function queryAllProductClassForCascader () {
  return http({
    url: '/api/productClass/queryAllProductClassForCascader',
    method: 'get'
  })
}
// 查询所有产品分类信息有状态
export function queryAllUseProductClassList () {
  return http({
    url: '/api/productClass/queryAllUseProductClassList',
    method: 'get'
  })
}
// 修改品牌状态
export function updateBrandFlagById (id, data) {
  return http({
    url: `/api/brandBase/updateBrandFlagById/${id}`,
    method: 'post',
    params: {
      flag: data
    }
  })
}
// 修改品牌推荐状态
export function updateBrandRecomendById (id, data) {
  return http({
    url: `/api/brandBase/updateBrandRecomendById/${id}`,
    method: 'get',
    params: {
      flag: data
    }
  })
}
// 新增品牌
export function brandBaseAdd (data) {
  return http({
    url: '/api/brandBase/add',
    method: 'post',
    data: data
  })
}
// 修改品牌
export function brandBaseUpdateById (data) {
  return http({
    url: '/api/brandBase/updateById',
    method: 'post',
    data: data
  })
}
// 分页查询所有系列列表
export function brandSeriesQueryPageAll (page, size, data) {
  return http({
    url: `/api/brandSeries/queryPageAll/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 新增系列
export function brandSeriesAdd (data) {
  return http({
    url: '/api/brandSeries/add',
    method: 'post',
    data: data
  })
}
// 修改系列
export function brandSeriesUpdateById (data) {
  return http({
    url: '/api/brandSeries/updateById',
    method: 'post',
    data: data
  })
}
// 修改系列状态
export function updateBrandSeriesFlagById (id, data) {
  return http({
    url: `/api/brandSeries/updateBrandSeriesFlagById/${id}`,
    method: 'post',
    params: {
      flag: data
    }
  })
}
// 查询所有系列组
export function queryAllSeriesGroup () {
  return http({
    url: '/api/brandGroup/queryAllSeriesGroup',
    method: 'get'
  })
}
// 品牌名称
export function queryAllBrandForSelect () {
  return http({
    url: '/api/brandBase/queryAllBrandForSelect',
    method: 'get'
  })
}
// 修改系列组
export function updateSeriesGroup (data) {
  return http({
    url: '/api/brandSeries/updateSeriesGroup',
    method: 'post',
    data: data
  })
}
// 分页查询所有品牌系数列表
export function queryPageAllBrandCoeficient (page, size, data) {
  return http({
    url: `/api/brandBase/queryPageAllBrandCoeficient/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 系列系数列表
export function queryPageAllBrandSeriesCoefficient (page, size, data) {
  return http({
    url: `/api/brandSeries/queryPageAllBrandSeriesCoefficient/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 单品系数列表
export function queryAllProductCoefficient (page, size, data) {
  return http({
    url: `/api/productBase/queryAllProductCoefficient/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 启用/停用 品牌系数
export function updateBrandCoefficientState (id, data) {
  return http({
    url: `/api/brandBase/updateBrandCoefficientState/${id}`,
    method: 'post',
    params: {
      isStopCoefficient: data
    }
  })
}
// 启用/停用 系列系数
export function updateSeriesCoefficientState (id, data) {
  return http({
    url: `/api/brandSeries/updateBrandCoefficient/${id}`,
    method: 'post',
    params: {
      isStopCoefficient: data
    }
  })
}
// 启用/停用 单品系数
export function updateOffProductCoefficientState (id, isStopCoefficient) {
  return http({
    url: `/api/productBase/onOffProductCoefficient/${id}/${isStopCoefficient}`,
    method: 'post'
  })
}
// 编辑品牌系数
export function updateBrandCoefficient (id, data) {
  return http({
    url: `/api/brandBase/updateBrandCoefficient/${id}`,
    method: 'post',
    params: {
      coefficient: data
    }
  })
}
// 编辑系列系数
export function updateSeriesCoefficient (data) {
  return http({
    url: '/api/brandSeries/updateSeriesCoefficient/',
    method: 'post',
    data: data
  })
}
// 编辑单品系数
export function updateProductCoefficient (id, data) {
  return http({
    url: `/api/productBase/updateProductCoefficient/${id}`,
    method: 'post',
    params: {
      coefficient: data
    }
  })
}
// 查询全局系数设置
export function productPriceSettingQuery (data) {
  return http({
    url: '/api/productPricesetting/query',
    method: 'post',
    data: data
  })
}
// 更新全局系数设置
export function productPriceSettingUpdate (data) {
  return http({
    url: '/api/productPricesetting/update',
    method: 'post',
    data: data
  })
}
// 添加分类
export function productClassAdd (data) {
  return http({
    url: '/api/productClass/add',
    method: 'post',
    data: data
  })
}
// 修改品类状态
export function productClassChangeStateById (flag, id) {
  return http({
    url: '/api/productClass/changeStateById',
    method: 'post',
    params: {
      flag: flag,
      id: id
    }
  })
}
// 修改品类
export function productClassUpdateById (data) {
  return http({
    url: '/api/productClass/updateById',
    method: 'post',
    data: data
  })
}
// 获取产品分类右侧列表
export function queryAllProductClassBylevel (level, page, size, id) {
  return http({
    url: `api/productClass/queryAllProductClassBylevel/${level}/${page}/${size}`,
    method: 'post',
    params: {
      id: id
    }
  })
}
// 根据id编辑分类
export function productClassQueryById (id) {
  return http({
    url: `/api/productClass/queryById/${id}`,
    method: 'get'
  })
}
// 修改品牌管理序号
export function updateBrandRecomendSortNumberById (id, sort) {
  return http({
    url: `/api/brandBase/updateBrandRecomendSortNumberById/${id}/${sort}`,
    method: 'get'
  })
}
// 产品选型
export function queryProductSelection (page, size, data) {
  return http({
    url: `/api/productBase/queryProductSelection/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 查询所有产品参数
export function queryAllProductParam (page, size) {
  return http({
    url: `/api/productClassParam/queryAllProductParam/${page}/${size}`,
    method: 'get'
  })
}
// 根据品牌id获得所属系列
export function querySeriesByMultiBrandId (page, size, ids) {
  return http({
    url: `/api/brandSeries/querySeriesByMultiBrandId/${page}/${size}`,
    method: 'post',
    params: {
      ids: ids
    }
  })
}
// (选型)根据品类ID查询所有品牌和品牌系列
export function queryAllBrandWithBrandSeries (id) {
  return http({
    url: `/api/productClass/queryAllBrandWithBrandSeries/${id}`,
    method: 'get'
  })
}
// 同类产品推荐
export function queryProductRecomend (brandId, pcid, pid) {
  return http({
    url: `/api/productBase/queryProductRecomend/${brandId}/${pcid}/${pid}`,
    method: 'get'
  })
}
// 添加临时产品
export function addTempProduct (data) {
  return http({
    url: '/api/productBase/addTempProduct',
    method: 'post',
    data: data
  })
}
// 根据产品ID获得所有信息(编辑)

// export function queryProductByIdForEditId (id) {
//   return http({
//     url: `/api/productBase/queryProductByIdForEdit/${id}`,
//     method: 'post'
//   })
// }

// 产品详情页-审批临时产品
export function examineByProId (data) {
  return http({
    url: '/api/productBase/examineByProId',
    method: 'post',
    data: data
  })
}
// 产品合并审批操作(临时产品合并到主产品)[需先进行参数合并检查]
export function mergeProduct (tempId, mainId) {
  return http({
    url: `/api/productBase/mergeProduct/${tempId}/${mainId}`,
    method: 'post'
  })
}
// 产品导入-确认接口

export function addImportProduct (data) {
  return http({
    url: '/api/productBase/addImportProduct',
    method: 'post',
    data: data

  })
}
// 品牌系数 -确认接口

export function addImportBrandCoefficient (data) {
  return http({
    url: '/api/brandBase/addImportBrandCoefficient',
    method: 'post',
    data: data

  })
}
// 客户-批量导入
export function addByUpload (isPublic, data) {
  return http({
    url: `/api/customerBase/addByUpload/${isPublic}`,
    method: 'post',
    data: data

  })
}
// 系列系数导入-确认
export function addImportBrandSeries (data) {
  return http({
    url: '/api/brandSeries/addImportBrandSeries',
    method: 'post',
    data: data
  })
}
// 型号系数导入-确认
export function addImportProductModel (data) {
  return http({
    url: '/api/productBase/addImportProductModel',
    method: 'post',
    data: data
  })
}
// 采购询价-询价-确认

export function addImportEnquiry (data) {
  return http({
    url: '/api/orderManualInquiry/addImportEnquiry',
    method: 'post',
    data: data
  })
}
// 采购清单-导入
export function StockAffirm (data) {
  return http({
    url: '/api/orderContractStockupPurchase/StockAffirm',
    method: 'post',
    data: data
  })
}
// 采购合同产品选型导入-确认
export function contractContentAffirm (data) {
  return http({
    url: '/api/purchaseContractContent/contractContentAffirm',
    method: 'post',
    data: data
  })
}

// 仓储-货架导入确认

export function addImportShelvesConfirm (sbId, data) {
  return http({
    url: `/api/storageShelves/addImportShelvesConfirm/${sbId}`,
    method: 'post',
    data: data
  })
}
// 仓库 期初库存-确认
export function addShelvesProductAffirm (sbId, data) {
  return http({
    url: `api/storageShelvesProduct/addShelvesProductAffirm/${sbId}`,
    method: 'post',
    data: data
  })
}

// 财务-银行对账-确认
export function addBankReceiptImport (data) {
  return http({
    url: '/api/finaceBankReceipt/addBankReceiptImport',
    method: 'post',
    data: data
  })
}

// 财务-待处理付款申请
export function addImportFinancePay (data) {
  return http({
    url: '/api/financePayRequestSource/addImportFinancePay',
    method: 'post',
    data: data
  })
}

// 到处财务-待处理 付款申请
export function exportFinancePay (data) {
  return http({
    url: '/api/financePayRequestSource/financePayCoeDerive',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 财务-待处理开票申请
export function orderInvoiceCoeDerive (data) {
  return http({
    url: '/api/orderContractInvoice/orderInvoiceCoeDerive',
    method: 'post',
    responseType: 'blob',
    data
  })
}
